module.exports = __webpack_public_path__ + "media/images/uscc_meeting-d1dc19415d5cd8ede62ab6a9426b4f7f.png";